import React from "react";

const emailWrapStyle = {
  backgroundColor: "#f4f4f4",
  padding: "24px 12px",
  fontFamily: "Arial, sans-serif",
  fontSize: "14px",
  color: "#333"
};

const emailCardStyle = {
  maxWidth: "600px",
  margin: "0 auto",
  backgroundColor: "#ffffff",
  borderRadius: "6px",
  overflow: "hidden",
  boxShadow: "0 2px 12px rgba(0,0,0,0.10)"
};

const headerStyle = {
  backgroundColor: "#1a7f5a",
  padding: "20px 24px",
  textAlign: "center",
  color: "#fff"
};

const bodyStyle = {
  padding: "24px",
  lineHeight: "1.7"
};

const footerStyle = {
  backgroundColor: "#f9f9f9",
  borderTop: "1px solid #e8e8e8",
  padding: "16px 24px",
  fontSize: "12px",
  color: "#888",
  textAlign: "center"
};

const imgStyle = {
  maxWidth: "200px",
  width: "100%",
  height: "auto",
  display: "block",
  margin: "8px auto"
};

const View = props => {
  const { data } = props;

  return (
    <div style={emailWrapStyle}>
      {/* Sender info bar */}
      {data?.senderEmail && (
        <div
          style={{
            maxWidth: "600px",
            margin: "0 auto 8px",
            fontSize: "12px",
            color: "#888"
          }}
        >
          <strong>From:</strong> {data.senderEmail}
        </div>
      )}
      {data?.emailDisabled && (
        <div
          style={{
            maxWidth: "600px",
            margin: "0 auto 8px",
            padding: "8px 12px",
            backgroundColor: "#fff3cd",
            borderRadius: "4px",
            fontSize: "13px",
            color: "#856404"
          }}
        >
          ⚠️ Email sending is <strong>disabled</strong> for this store —
          customers will not receive emails.
        </div>
      )}
      <div style={emailCardStyle}>
        {/* Header */}
        <div style={headerStyle}>
          <div
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "10px"
            }}
          >
            {data?.title || "Receipt"}
          </div>
          {data?.titleImageList?.map((el, i) => (
            <a key={i} href={el?.imageLink} target="_blank" rel="noreferrer">
              <img src={el?.image} alt="Header" style={imgStyle} />
            </a>
          ))}
        </div>

        {/* Body */}
        <div style={bodyStyle}>
          {data?.body1 || data?.body2 || data?.body3 ? (
            <>
              <div
                dangerouslySetInnerHTML={{ __html: data?.body1 }}
                style={{ marginBottom: "12px" }}
              />
              <div
                dangerouslySetInnerHTML={{ __html: data?.body2 }}
                style={{ marginBottom: "12px" }}
              />
              <div dangerouslySetInnerHTML={{ __html: data?.body3 }} />
            </>
          ) : (
            <p style={{ color: "#aaa" }}>(No body content)</p>
          )}
        </div>

        {/* Footer */}
        <div style={footerStyle}>
          <div
            dangerouslySetInnerHTML={{ __html: data?.footer || "" }}
            style={{ marginBottom: "10px" }}
          />
          {data?.footerImageList?.map((el, i) => (
            <a key={i} href={el?.imageLink} target="_blank" rel="noreferrer">
              <img
                src={el?.image}
                alt="Footer"
                style={{ ...imgStyle, maxWidth: "150px" }}
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default View;
